import * as React from 'react';

import ModalAllowTextMessages from '~/components/Modals/ModalAllowTextMessages';
import ModalChatInitProgress from '~/components/Modals/ModalChatInitProgress';
import ModalRegisterAnonymously from '~/components/Modals/ModalRegisterAnonymously';
import ModalCompleteProfile from '~/components/Modals/ModalCompleteProfile';
import ModalSignUpRequest from '~/components/Modals/ModalSignUpRequest';
import ModalUpgradeToPaid from '~/components/Modals/ModalUpgradeToPaid';
import ModalVerifyProfile from '~/components/Modals/ModalVerifyProfile';
import ModalGoldMembership from '~/components/Modals/ModalGoldMembership/ModalGoldMembership';
import ModalAllowLocation from '~/components/Modals/ModalAllowLocation';
import ModalVerificationCode from '~/components/Modals/ModalVerificationCode';
import ModalChatUnavailable from '~/components/Modals/ModalChatUnavailable';
import ModalAllowNotifications from '~/components/Modals/ModalAllowNotifications';
import ModalTwoFAResendNotice from '~/components/Modals/ModalTwoFAResendNotice';
import ModalOrientationChange from '~/components/Modals/ModalOrientationChange';
import ModalRequestGeoLocation from '~/components/Modals/ModalRequestGeoLocation';
import ModalLocationDisabledFlash from '~/components/Modals/ModalLocationDisabledFlash';
import ModalUnauthorized from '~/components/Modals/ModalUnauthorized';
import ModalError from '~/components/Modals/ModalError';

const ModalsManager: React.FC = () => {
  return (
    <>
      <ModalChatInitProgress />
      <ModalSignUpRequest />
      <ModalUnauthorized />
      <ModalRegisterAnonymously />
      <ModalVerificationCode />
      <ModalAllowTextMessages />
      <ModalCompleteProfile />
      <ModalUpgradeToPaid simple />
      <ModalVerifyProfile />
      <ModalGoldMembership />
      <ModalAllowLocation />
      <ModalChatUnavailable />
      <ModalAllowNotifications />
      <ModalTwoFAResendNotice />
      <ModalOrientationChange />
      <ModalRequestGeoLocation />
      <ModalLocationDisabledFlash />
      <ModalError />
    </>
  );
};

export default ModalsManager;
